import lodash from 'lodash'

export function serializeValues(values: any): any {
  return {
    ...lodash.omit(values, ['value', 'isDelete']),
    value: lodash.get(values, 'value.value'),
    valueCurrency: lodash.get(values, 'value.currency'),
  }
}

export function parseValues(values: any): any {
  return {
    ...lodash.omit(values, ['value', 'valueCurrency']),
    value: {
      value: lodash.get(values, 'value'),
      currency: lodash.get(values, 'valueCurrency'),
    },
    preferenceCode: String(values.preferenceCode),
  }
}
